import { useQuery } from '@tanstack/react-query';
import { getPostById } from '../api/postApi';

export function useEditPost(id: string | undefined) {
  return useQuery({
    queryKey: ['posts', id],
    queryFn: () => getPostById(id!),
    enabled: !!id,
  });
}